import React from 'react';
import CardFrame from './CardFrame';

/**
 * Mini start-card preview used in FrameStylePicker and theme library picker.
 * Renders the real CardFrame + start-card content so picker previews match in-game start cards.
 */
const StartCardPreview = ({
  title = 'Game Title',
  description = 'Instructions here',
  colors = {},
  frameStyle = 'clean',
  font = null,
  className = '',
  overlayEffect = null,
  backgroundPattern = null,
  layout = 'stack',
}) => {
  const isCentered = layout === 'centered' || layout === 'heroCentered';
  const align = isCentered ? 'text-center' : 'text-left';
  const cardColors = {
    primaryAction: colors?.primaryAction || '#7C3AED',
    secondaryAction: colors?.secondaryAction || '#F97316',
    surface: colors?.surface || '#FFFFFF',
    background: colors?.background || '#2C3E50',
    primary: colors?.primary || '#1F2937',
    text: colors?.text || '#6B7280',
    buttonText: colors?.buttonText || '#FFFFFF',
  };

  const fontFamily = font ? `"${font}", sans-serif` : 'inherit';
  const isPixel = frameStyle === 'pixel';

  return (
    <CardFrame
      frameStyle={frameStyle}
      colors={cardColors}
      animate={false}
      fullWidth
      className={`${className} ${align}`}
      overlayEffect={overlayEffect}
      backgroundPattern={backgroundPattern}
    >
      <div className={`p-3 ${align}`}>
        <div
          className={`text-[10px] font-semibold truncate mb-1 ${align}`}
          style={{ color: cardColors.primary, fontFamily }}
        >
          {title}
        </div>
        <div
          className={`text-[8px] truncate mb-2 opacity-80 ${align}`}
          style={{ color: cardColors.text, fontFamily }}
        >
          {description}
        </div>
        <div
          className="w-full py-1.5 rounded text-[9px] font-semibold text-center"
          style={{
            backgroundColor: cardColors.primaryAction,
            color: cardColors.buttonText,
            fontFamily,
            borderRadius: isPixel ? 0 : 4,
          }}
        >
          Start
        </div>
      </div>
    </CardFrame>
  );
};

export default StartCardPreview;
